// removed by extract-text-webpack-plugin
module.exports = {"headerOrange":"src-assets-css----header-module---headerOrange---1rGNr","bgOrangeGrad":"src-assets-css----header-module---bgOrangeGrad---_w459","headerBlue":"src-assets-css----header-module---headerBlue---2OVfe","bgBlueGrad":"src-assets-css----header-module---bgBlueGrad---36c0A","headerPurple":"src-assets-css----header-module---headerPurple---QQw_d","bgPurpleGrad":"src-assets-css----header-module---bgPurpleGrad---nkHfZ"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/header.module.css
// module id = 441
// module chunks = 168707334958949